import { GetCategoryType } from './category.actions';

const initialState = {
  data: [],
  isLoading: false,
};

export const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GetCategoryType.REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case GetCategoryType.SUCCESS: {
      const index = state.data.findIndex(v => v._id === action.payload._id);

      return {
        ...state,
        data:
          index !== -1
            ? [...state.data.slice(0, index), action.payload, ...state.data.slice(index + 1)]
            : [...state.data, action.payload],
        isLoading: false,
      };
    }

    case GetCategoryType.FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
};
